/**
 * External Imports
 */
import { FC } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

/**
 * Internal Imports
 */
import MainNav from './mainNav';
import SubNav from './subNav';
import SubNavAccount from './subNavAccount/SubNavAccount';
import { RootState } from '../../redux/store';
import { useFeatures } from '../../services/Features/features';

/**
 * Global Type Definition Imports
 */
import { AuthUserProps } from '../../config/interfaces';

interface HeaderProps {
  facilityTitle: string;
  authorizedUser: AuthUserProps | undefined;
  divisionTitle: string;
}

const Header: FC<HeaderProps> = ({
  authorizedUser,
  facilityTitle,
  divisionTitle
}) => {
  const { pathname } = useLocation();
  const { isCSCEnabled } = useFeatures();

  return (
    <div id="Header">
      <MainNav
        firstName={authorizedUser?.firstName ?? ''}
        lastName={authorizedUser?.lastName ?? ''}
      />
      {!pathname.includes('/account') &&
        !pathname.includes('/profile') &&
        !(pathname.includes('/support') && !isCSCEnabled) && (
          <SubNav facilityTitle={facilityTitle} divisionTitle={divisionTitle} />
        )}
      {pathname.includes('/account') && <SubNavAccount />}
    </div>
  );
};

const mapReduxStateToProps = (state: RootState) => {
  return {
    authorizedUser: state.AuthorizedUser.authorizedUser
  };
};

export default connect(mapReduxStateToProps)(Header);
